import * as msalClass from "@azure/msal-browser";
import * as auth from '../auth';
import config from '../config';
import { store } from "../store";

const ua = window.navigator.userAgent;
const msie = ua.indexOf("MSIE ");
const msie11 = ua.indexOf("Trident/");
export const isIE = msie > 0 || msie11 > 0;

const msalConfig = {
  auth: {
      clientId: config.clientId,
      authority: "https://login.microsoftonline.com/common/",
      redirectUri: config.redirectUri + 'accept',
      navigateToLoginRequestUrl: false,
      postLogoutRedirectUri: config.redirectUri + 'login',
  },
  cache: {
      cacheLocation: "localStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// // Add here scopes for id token to be used at MS Identity Platform endpoints.
const loginRequest = {
  scopes: ["user.read"],
  prompt: 'select_account'
};

const tokenRequest = {
  scopes: ["user.read"]
}

export const msal = new msalClass.PublicClientApplication(msalConfig);

msal.handleRedirectPromise()
.then(response => {
  if (response !== null) {
    auth.setupAuth(response);
  }
})
.catch(err => {
    console.error(err);
});

// function handleResponse(resp) {
//   if (resp !== null) {
//       accountId = resp.account.homeAccountId;
//       msal.setActiveAccount(resp.account);
//       // showWelcomeMessage(resp.account);
//       // seeProfileRedirect();
//   } else {
//       // need to call getAccount here?
//       const currentAccounts = msal.getAllAccounts();
//       if (!currentAccounts || currentAccounts.length < 1) {
//           signIn("loginRedirect");
//       } else if (currentAccounts.length > 1) {
//           // Add choose account code here
//       } else if (currentAccounts.length === 1) {
//           accountId = currentAccounts[0].homeAccountId;
//           //showWelcomeMessage(currentAccounts[0]);
//       }
//   }
// }

async function getActiveAccount() {
  let account = msal.getActiveAccount();
  if (account != null) {
    return account;
  }

  let accounts = msal.getAllAccounts();
  if (accounts.length === 1) {
    msal.setActiveAccount(accounts[0]);
    return accounts[0];
  }

  let user = store.getters.getUser;
  if (accounts.length > 0 && user != null && accounts.find(a => a.username && a.username.toLocaleLowerCase() == user.email)) {
    account = accounts.find(a => a.username && a.username.toLocaleLowerCase() == user.email);
    return account;
  }

  return await signIn()
    .then(response => {
      msal.setActiveAccount(response.account);
      return account;
    });
}

export async function signIn() {
  return msal.loginRedirect(loginRequest);
  // if (isIE) {
  //   return msal.loginRedirect(loginRequest);
  // } else {
  //   return await msal.loginPopup(loginRequest)
  //     .catch(async (error) => {
  //       console.error(error);
  //     });
  // }
}

// export function signOut() {
//   const logoutRequest = {
//       account: msal.getAccountByHomeId(accountId)
//   };
//   msal.logout(logoutRequest);
// }

export async function getToken() {
  return getTokenRedirect();
  // if (isIE) {
  //   return getTokenRedirect();
  // } else {
  //   return getTokenPopup();
  // }
}

async function getTokenPopup() {
  let request = tokenRequest;
  request.account = await getActiveAccount();
  return await msal.acquireTokenSilent(request)
    .catch(async (error) => {
      console.log("silent token acquisition fails.");
      if (error instanceof msalClass.InteractionRequiredAuthError) {
          console.log("acquiring token using popup");
          return msal.acquireTokenPopup(request);
      } else {
        throw error;
      }
  });
}

// This function can be removed if you do not need to support IE
async function getTokenRedirect() {
  let request = tokenRequest;
  request.account = await getActiveAccount();
  return await msal.acquireTokenSilent(request)
    .catch(async (error) => {
      console.log("silent token acquisition fails.");
      if (error instanceof msalClass.InteractionRequiredAuthError) {
        // fallback to interaction when silent call fails
        console.log("acquiring token using redirect");
        msal.acquireTokenRedirect(request);
      } else {
        throw error;
      }
    });
}